import { render, staticRenderFns } from "./ViewCovidVaccine.vue?vue&type=template&id=0c44cc8a&scoped=true&"
import script from "./ViewCovidVaccine.vue?vue&type=script&lang=js&"
export * from "./ViewCovidVaccine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44cc8a",
  null
  
)

export default component.exports